import { render, staticRenderFns } from "./ux-grid.vue?vue&type=template&id=5dec7100&"
import script from "./ux-grid.vue?vue&type=script&lang=tsx&"
export * from "./ux-grid.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports